import { render } from "./SerieList.vue?vue&type=template&id=1dbc81f1&scoped=true"
import script from "./SerieList.vue?vue&type=script&lang=js"
export * from "./SerieList.vue?vue&type=script&lang=js"

import "./SerieList.vue?vue&type=style&index=0&id=1dbc81f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbc81f1"]])

export default __exports__